import { useEffect, useMemo, useRef, useState } from "react";
import SearchTitle from "./update-tool-modal/search-title.component";
import useToggleRow from "../../../../hooks/toggle-row.hook";
import { Flaggers } from "../../../../common/store/flaggers/flaggers.enum";
import { useEntity } from "../../../../hooks/use-entity.hook";
import cn from "../../../../Utils/class-names.utils";
import { getAccessStateValue, HGHighlightText } from "../../../App/App";
import CrossCircleIcon from "../../../icons/cross-circle.icon";
import NoteSection from "../../note-section/note-section.component";
import securityStackUtils from "../../../../Utils/security-stack.utils";
import AddToolDropdown from "./add-tool-dropdown/add-tool.dropdown";
import ConnectedToolItem from "./connected-tool-item.component";
import integrationUtils from "../../../../Utils/integration.utils";
import ImageLoader from "../../../Common/ImageLoader";
import { Spinner } from "react-bootstrap";
import CrossIcon from "../../../icons/cross.icon";


const AttestationRow = ({
  tool,
  submitNote,
  isNoteLoading,
  searchMspTools,
  refreshIntegrsInfo,
  toolData,
  onToolClick,
  onPracticeClick,
  removePracticeTool,
  rowParentId,
  nestedOffset = 0,
  hideChilds = true,
  addNewIntegration,
  technologyAnswerState,
  isView = false,
  onChildToggle = () => {},
  removeIntegration = ({ integrationId, technologyEnum, isCustom }) => {},
}) => {
  const [isTechnologyAnswerStateLoading, setIsTechnologyAnswerStateLoading] = useState(false);
  const pointRef = useRef(null);
  const childContainerRef = useRef(null);
  const hasChilds = tool.Grouping && tool.IsChild === false;
  const isChildOf = tool.Grouping && tool.IsChild === true;
  const childs = useMemo(() => (
    hasChilds ? toolData.filter((itemToolData) => itemToolData.IsChild && itemToolData.Grouping === tool.Grouping) : []
  ), [toolData, tool, hasChilds]);
  const hasChildToolTitle = useMemo(() => (
    childs.some((child) => SearchTitle({ title: child?.TechnologyTitle, searchValue: searchMspTools }))
  ), [childs, searchMspTools]);
  const toolTitle = SearchTitle({ title: tool?.TechnologyTitle, searchValue: searchMspTools });
  const selectedToolTitle = useMemo(() => (
    tool?.SelectedTool_List?.some(
      (item) => SearchTitle({ title: item?.ToolName, searchValue: searchMspTools })
    )
  ), [tool, searchMspTools]);
  const practiceToolTitle = useMemo(() => (
    tool?.SelectedTool_List?.some((selectedTool) => 
      selectedTool?.PracticeTool_List?.some(
        (practiceTool) => SearchTitle({ title: practiceTool?.ToolName, searchValue: searchMspTools })
      )
    )
  ), [tool, searchMspTools]);
  const childSelectedToolTitle = useMemo(() => (
    childs.some((child) => child?.SelectedTool_List?.some(
      (item) => SearchTitle({ title: item?.ToolName, searchValue: searchMspTools })
    ))
  ), [childs, searchMspTools]);
  const childPracticeToolTitle = useMemo(() => (
    childs.some((child) => child?.SelectedTool_List?.some((selectedTool) => 
      selectedTool?.PracticeTool_List?.some(
        (practiceTool) => SearchTitle({ title: practiceTool?.ToolName, searchValue: searchMspTools })
      )
    ))
  ), [childs, searchMspTools]);
  const { toggleRow, refreshState, closeAllPanels, setOpen, isOpenFixed, panelRef } = useToggleRow({ rowRef: pointRef, parentId: rowParentId, panelVisibleOut: true });
  const childWrapperId = useMemo(() => hasChilds ? `sec-stack-child-rows-${tool?.TechnologyTitle}` : null, [tool, hasChilds]);
  const displayYellowDot = hasChilds ? childs?.some(item => !item?.ResponseProvided) : !tool?.ResponseProvided;
  const isPractice = tool?.ContriType == 1 ? true : false;
  const { entityData: removePracticeToolFlaggerData } = useEntity({ entityType: Flaggers.RemovePracticeToolFlagger })

  const handleCrossClick = (integrationId, isCustom) => {
    return removeIntegration({ integrationId, technologyEnum: tool?.TechnologyEnum, isCustom });
  }

  const handleToolClick = (e, tool) => {
    const isPractice = tool?.IsPractice;
    const toolId = tool.obj_IntegrationId || tool.ToolId;
    e?.stopPropagation?.();
    if (isPractice) {
      onPracticeClick({
        ...tool,
        IntegrationId: toolId,
        ToolName: tool.ToolName,
        Selected: true,
        preselectedPracticeTypes: [toolId],
      });
      return;
    }
    onToolClick({
      ...tool,
      obj_IntegrationId: toolId,
    });
  }

  const handleAddNewIntegration = (technologyEnum, IntegrationId, toolName, selected, isPractice) => {
    if (isPractice) {
      onPracticeClick({
        TechnologyEnum: technologyEnum,
        IntegrationId,
        ToolName: toolName,
        Selected: selected,
        preselectedPracticeTypes: [IntegrationId],
      });
      document.body.click();
      return;
    }
    return addNewIntegration(technologyEnum, IntegrationId, toolName, selected);
  }

  const handleStackToolClick = (integration) => {
    if (isPractice) {
      onPracticeClick({
        ...integration,
        TechnologyEnum: tool?.TechnologyEnum,
        IntegrationId: integration.IntegrationId,
        ToolName: integration.IntegrationName,
        Selected: true,
      });
      return;
    }
    onToolClick({
      ...integration,
      obj_IntegrationId: integration.IntegrationId,
      ToolName: integration.IntegrationName,
      ToolIcon: integration.ToolIcon,
    });
  }

  const handleNewToolClick = (item) => {
    if (isPractice) {
      onPracticeClick({
        ...item,
        TechnologyEnum: tool?.TechnologyEnum,
        IntegrationId: item.IntegrationId,
        ToolName: item.ToolName,
        Selected: true,
        preselectedPracticeTypes: [tool.IntegrationId],
      });
      return; 
    }
    onToolClick({
      ...item,
      technologyList: [tool?.TechnologyEnum],
    });
  }

  const handlePracticeToolRemove = ({ practiceId, toolId }) => {
    removePracticeTool({
      practiceId,
      toolId,
    });
  }

  const handleTechnologyAnswerState = (value) => {
    setIsTechnologyAnswerStateLoading(true);
    technologyAnswerState({
      technologyEnum: tool?.TechnologyEnum,
      value,
    })?.finally(() => {
      setIsTechnologyAnswerStateLoading(false);
    });
  }

  const handleToggleRow = () => {
    toggleRow();
    const extraHeight = childContainerRef?.current?.scrollHeight || childContainerRef?.current?.clientHeight || 0;
    onChildToggle(extraHeight);
  }

  const handleChildToggle = (extraHeight) => {
    const panelExtraHeight = panelRef?.current?.scrollHeight || panelRef?.current?.clientHeight || 0;
    refreshState(panelExtraHeight + extraHeight);
    setTimeout(() => {
      refreshState(panelExtraHeight + extraHeight);
    }, 350);
  }

  useEffect(() => {
    refreshState();
    if (!searchMspTools) {
      closeAllPanels();
      return;
    }
    if (!hasChildToolTitle && !toolTitle && !selectedToolTitle && !childSelectedToolTitle && !practiceToolTitle && !childPracticeToolTitle) return;
    setOpen(true);
  }, [searchMspTools]);

  if (!toolTitle && !selectedToolTitle && !hasChildToolTitle && !childSelectedToolTitle && !practiceToolTitle && !childPracticeToolTitle) return null;
  if (hideChilds && isChildOf) return null;

  return (
    <div
      className={cn(`point tool-wrapper-container`, {
        'open': isOpenFixed
      })}
      onClick={(e) => {
        if (
          getAccessStateValue(
            "AccessState_MSP_Security_Stack"
          ) < 3
        ) {
          return;
        }
        handleToggleRow();
        // refreshIntegrsInfo(tool?.TechnologyTitle, tool?.TechnologyEnum);
      }}
      ref={pointRef}
    >
      <div
        className="w-100 pointer tool-wrapper v2"
        style={{
          ...nestedOffset && {
            paddingLeft: `${nestedOffset}px`
          }
        }}
      >
        <img
          className="yellow-dot"
          alt=""
          src="/images/attack-surface/yellow-dot.svg"
          style={{
            visibility: `${displayYellowDot
              ? "visible"
              : "hidden"
              }`,
            ...nestedOffset && {
              paddingLeft: `${nestedOffset - 10}px`
            }
          }}
        />
        <div>
          <p className="f-14 line-height-22 f-500 m-0"
            dangerouslySetInnerHTML={{
              __html: HGHighlightText(
                tool?.TechnologyTitle,
                searchMspTools
              ),
            }}
          />
        </div>
        <div className="d-flex align-items-center justify-content-between w-100 h-100">
          {!isOpenFixed && tool?.ShowNoCapability ? (
            <div className="d-flex align-items-center gap-4 f-grey">
              <CrossCircleIcon />
              <span className="f-12 line-height-18 f-500">Not Supported</span>
            </div>
          ) : isOpenFixed && !hasChilds ? (
            <div className="f-12 line-height-18 f-darkgrey">
              Choose your {tool?.TechnologyTitle} {isPractice ? "practices and tools" : "tools"}
            </div>
          ) : (
            <div>
              {tool?.ShowSelectedTool && !hasChilds && (
                <div className="d-flex flex-wrap" style={{ gap: '4px' }}>
                  {tool?.SelectedTool_List?.map(
                    (connectedTool, connectedToolIndex) => (
                      <div key={`connected-tool-${connectedTool.ToolName}-${connectedToolIndex}`} onClick={(e) => handleToolClick(e, connectedTool)}>
                        <ToolInRow
                          idKey={'obj_IntegrationId'}
                          tool={connectedTool}
                          searchValue={searchMspTools}
                          onCrossClick={handleCrossClick}
                          showCross={!isView}
                        />
                      </div>
                    )
                  )}
                </div>
              )}
            </div>
          )}
          
          {hasChilds && (
            <div className="d-flex align-items-center h-100">
              <img
                alt=""
                className={`arrow ${isOpenFixed ? 'open' : ''}`}
                src="/images/attack-surface/chevron-down.svg"
              />
            </div>
          )}
        </div>
      </div>
      <div
        className="panel"
        onClick={(e) => e.stopPropagation()}
        ref={panelRef}
      >
        {
          hasChilds ? (
            <div id={childWrapperId} ref={childContainerRef}>
              {childs.map((child, childIndex) => (
                <AttestationRow
                  key={`child-${childIndex}-${child.TechnologyTitle}`}
                  tool={child}
                  toolData={toolData}
                  rowParentId={childWrapperId}
                  searchMspTools={searchMspTools}
                  refreshIntegrsInfo={refreshIntegrsInfo}
                  nestedOffset={48}
                  hideChilds={false}
                  displayTopBorder={childIndex === 0}
                  addNewIntegration={addNewIntegration}
                  technologyAnswerState={technologyAnswerState}
                  onToolClick={onToolClick}
                  onPracticeClick={onPracticeClick}
                  removePracticeTool={removePracticeTool}
                  onChildToggle={handleChildToggle}
                  submitNote={submitNote}
                  isNoteLoading={isNoteLoading}
                  removeIntegration={removeIntegration}
                  isView={isView}
                />
              ))}
            </div>
          ) : (
            <div className="panel-content"
              style={{
                ...nestedOffset && {
                  paddingLeft: `${nestedOffset - 10}px`
                }
              }}
            >
              <div className="panel-content-empty" />
              {tool?.ShowNoCapability ? (
                <NoteSection
                  refetchTools={() => { }}
                  submitNote={submitNote}
                  isLoading={isNoteLoading || isTechnologyAnswerStateLoading}
                  value={tool?.ScoreAttestationRow?.NoteForNoAnswer}
                  userDetails={tool?.ScoreAttestationRow?.UserDetailsVM}
                  LastUpdatedBy={tool?.ScoreAttestationRow?.LastUpdatedBy}
                  LastUpdated={tool?.ScoreAttestationRow?.LastUpdated}
                  placeholder="Provide description..."
                  showGenerateButton
                  buildGeneratePrompt={({ language }) => {
                    return securityStackUtils.getSecStackNoGeneratePrompt(tool?.ContriType, tool?.TechnologyTitle, language);
                  }}
                  showTrashButton
                  onTrashButtonClick={() => {
                    handleTechnologyAnswerState(false);
                  }}
                  onResize={(target) => {
                    refreshState();
                  }}
                  isView={isView}
                />
              ) : (
                <div className="d-flex flex-column gap-8">
                  {tool?.SelectedTool_List?.map(
                    (connectedTool, connectedToolIndex) => (
                      <div key={`connected-tool-${connectedTool.ToolName}-${connectedToolIndex}`} className="d-flex flex-column gap-8 flex-wrap">
                        <ToolInPanel 
                          tool={connectedTool}
                          searchValue={searchMspTools}
                          onToolClick={() => handleToolClick(undefined, connectedTool)}
                          onCrossClick={handleCrossClick}
                          showCross={!isView}
                        />
                        <div className="d-flex align-items-center gap-8 flex-wrap" style={{ marginLeft: '25px' }}>
                          {connectedTool?.PracticeTool_List?.map((practiceTool, practiceToolIndex) => {
                            const compositeKey = `${connectedTool.obj_IntegrationId}-${practiceTool.ToolId}`;
                            const isRemoving = removePracticeToolFlaggerData?.[compositeKey];
                            return (
                              <div key={`practice-tool-${practiceTool.ToolName}-${practiceToolIndex}`} className="pointer" onClick={(e) => handleToolClick(e, practiceTool)}>
                                <ToolInRow
                                  idKey={'ToolId'}
                                  key={`practice-tool-${practiceTool.ToolName}-${practiceToolIndex}`}
                                  tool={practiceTool}
                                  searchValue={searchMspTools}
                                  onCrossClick={() => handlePracticeToolRemove({ practiceId: connectedTool.obj_IntegrationId, toolId: practiceTool.ToolId })}
                                  isLoading={isRemoving}
                                  showCross={!isView}
                                />
                             </div>
                            )
                          })}
                        </div>
                      </div>
                    )
                  )}
                  {!isView && (
                    <AddToolDropdown
                      tool={tool} 
                      addNewIntegration={handleAddNewIntegration} 
                      technologyAnswerState={technologyAnswerState} 
                      onNewTool={handleNewToolClick} 
                      showOnlyPracticeTools={tool?.ContriType == 1} 
                      onStackToolClick={handleStackToolClick}
                      showToolsInStack={false}
                    />
                  )}
                </div>
              )}
            </div>
          )
        }
      </div>
    </div>
  );
}

export default AttestationRow;

const ToolInRow = ({ tool, idKey, searchValue, onCrossClick = () => {}, isLoading, showCross = true }) => {
  const [isLocalLoading, setIsLocalLoading] = useState(false);

  const handleCrossClick = async (e, integrationId) => {
    const isCustom = tool?.IsUserDefined;
    e.stopPropagation();
    setIsLocalLoading(true);
    await onCrossClick(integrationId, isCustom);
    setIsLocalLoading(false);
  }
  
  return (
    <ConnectedToolItem
      tool={tool}
      searchValue={searchValue}
      passedIdKey={idKey}
      showCross={showCross}
      onCrossClick={handleCrossClick}
      isLoading={isLocalLoading || isLoading}
    />
  )
}

const ToolInPanel = ({ tool, searchValue, onCrossClick, onToolClick, showCross = true }) => {
  const [isLoading, setIsLoading] = useState(false);
  const image = integrationUtils.getImagePath(tool?.obj_IntegrationId, tool?.ToolIcon);

  const handleCrossClick = (e, integrationId, isCustom) => {
    e.stopPropagation();
    setIsLoading(true);
    onCrossClick(integrationId, isCustom).then(() => {
      setIsLoading(false);
    }).catch(() => {
      setIsLoading(false);
    });
  }

  return (
    <div className="d-flex align-items-center justify-content-between">
      <div className="d-flex align-items-center gap-8 pointer" onClick={(e) => onToolClick(e, tool)}>
        <div />
        <ImageLoader
          alt=""
          width={16}
          height={16}
          className="rounded-full"
          style={{ marginLeft: '3px' }}
          src={image}
          noImageComponent={(
            <img
              alt=""
              width={16}
              height={16}
              className="rounded-full"
              style={{ marginLeft: '3px' }}
              src={"/images/attack-surface/generic2-dark.svg"}
            />
          )}
        />
        <span
          dangerouslySetInnerHTML={{
            __html: HGHighlightText(
              tool?.ToolName,
              searchValue
            ),
          }}
        />
      </div>
      {showCross && (
        <button className="cross-button my-button" onClick={(e) => handleCrossClick(e, tool?.obj_IntegrationId, tool?.IsUserDefined)}>
          {isLoading ? (
            <Spinner
              animation="border"
              variant="secondary"
              size="sm"
              style={{
                width: "12px",
                height: "12px",
                marginBottom: '2px'
              }}
            />
            ) : <CrossIcon className="f-darkgrey" />}
        </button>
      )}
    </div>
  )
}
